export default "__VITE_ASSET__B3Sqrj_J__"